import React from 'react';
import { motion } from 'framer-motion';
import { Gift, Sparkles } from 'lucide-react';
const bonuses = [{
  n: 'BONO #1',
  icon: '🎁',
  title: 'Contenido exclusivo por definir'
}, {
  n: 'BONO #2',
  icon: '🎁',
  title: 'Contenido exclusivo por definir'
}, {
  n: 'BONO #3',
  icon: '🎁',
  title: 'Contenido exclusivo por definir'
}, {
  n: 'BONO #4',
  icon: '🎁',
  title: 'Contenido exclusivo por definir'
}, {
  n: 'BONO #5',
  icon: '🎁',
  title: 'Contenido exclusivo por definir'
}, {
  n: 'BONO #6',
  icon: '🎁',
  title: 'Contenido exclusivo por definir'
}];
export function BonusSection() {
  return <section className="py-20 lg:py-24 bg-white" data-id="element-15">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-16">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-14 max-w-3xl mx-auto" data-id="element-17">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-brand-500 text-white font-bold text-xs uppercase tracking-wider mb-5 shadow-cta" data-id="element-18">
            <Gift className="w-4 h-4" data-id="element-19" /> 6 Regalos exclusivos
          </div>
          <h2 className="text-3xl md:text-5xl font-extrabold text-ink-900 mb-4 leading-tight tracking-tight" data-id="element-20">
            Además recibís{' '}
            <span className="text-brand-500" data-id="element-21">6 bonos GRATIS</span>
          </h2>
          <p className="text-lg text-ink-600" data-id="element-22">
            Por reservar hoy, sumás $90.000 en bonos exclusivos sin pagar un
            peso más.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 mb-10" data-id="element-23">
          {bonuses.map((b, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.08
        }} className="group relative bg-white rounded-2xl p-6 border-2 border-dashed border-brand-300 hover:border-brand-500 hover:shadow-card transition-all" data-id="element-24">
              {/* Bonus tag */}
              <div className="absolute -top-3 left-5 bg-ink-900 text-brand-500 text-[10px] font-black px-3 py-1 rounded-full uppercase tracking-widest shadow-md" data-id="element-25">
                {b.n}
              </div>
              <div className="flex items-start gap-4 mt-2" data-id="element-26">
                <div className="text-4xl bg-brand-50 w-16 h-16 rounded-2xl flex items-center justify-center shrink-0 group-hover:scale-110 transition-transform" data-id="element-27">
                  {b.icon}
                </div>
                <div className="flex-1" data-id="element-28">
                  <h3 className="font-extrabold text-ink-900 mb-3 leading-tight" data-id="element-29">
                    {b.title}
                  </h3>
                  <div className="flex items-center gap-2 flex-wrap" data-id="element-30">
                    <span className="text-ink-400 line-through text-sm font-medium" data-id="element-31">
                      $15.000
                    </span>
                    <span className="bg-success-light text-success font-black text-[10px] px-2 py-1 rounded uppercase tracking-wider" data-id="element-32">
                      GRATIS
                    </span>
                  </div>
                </div>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="max-w-2xl mx-auto bg-ink-900 rounded-3xl p-8 text-center shadow-2xl relative overflow-hidden" data-id="element-33">
          <div className="absolute top-0 right-0 w-40 h-40 bg-brand-500/20 rounded-full blur-3xl" data-id="element-34"></div>
          <div className="relative z-10" data-id="element-35">
            <Sparkles className="w-6 h-6 text-brand-500 mx-auto mb-3" data-id="element-36" />
            <p className="text-ink-400 font-bold mb-2 text-xs uppercase tracking-widest" data-id="element-37">
              Valor total de los bonos
            </p>
            <div className="flex items-center justify-center gap-4 text-4xl md:text-5xl font-black" data-id="element-38">
              <span className="text-ink-500 line-through" data-id="element-39">$90.000</span>
              <span className="text-brand-500" data-id="element-40">GRATIS</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}